import { timeToMinutes } from "./datetime";

export function distributeRecordsByColumns(records = []){
	const res = {};

	for (let index = 0; index < records.length; index++) {
		const record = records[index];

		if(!res[record.date_formated_2]) res[record.date_formated_2] = [];
		res[record.date_formated_2].push(record);
	}

	return res;
}

export function calculateRecordTopPosition(recordTimeStart){
	return 64/30 * (timeToMinutes(recordTimeStart) - timeToMinutes('10:00'))
}

export function calculateRecordHeight(recordTimeStart, recordTimeEnd){
	return 64/30 * (timeToMinutes(recordTimeEnd) - timeToMinutes(recordTimeStart)) - 1
}
